var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
var MemberImportComponent = /** @class */ (function () {
    function MemberImportComponent(util, apiService) {
        this.util = util;
        this.apiService = apiService;
    }
    MemberImportComponent.prototype.ngOnInit = function () {
        var that = this;
        $("#btnFile").change(function (e) {
            that.file_name = e.target.files[0].name;
            that.ConfirmUpload(this);
        });
    };
    MemberImportComponent.prototype.ConfirmUpload = function (input) {
        return __awaiter(this, void 0, void 0, function () {
            var that, ext, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        that = this;
                        if (!(input.files && input.files[0])) return [3 /*break*/, 3];
                        ext = $("#btnFile").val();
                        res = ext.split('.');
                        console.log(res);
                        if (!(res[1] == 'xls' || res[1] == 'xlsx')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.PreUpload()];
                    case 1:
                        _a.sent();
                        $('#lblData').html('Import data' + that.file_name);
                        $('#dlgConfirm').modal();
                        return [3 /*break*/, 3];
                    case 2:
                        that.util.ErrorDialog('File Not Support!');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MemberImportComponent.prototype.PreUpload = function () {
        var that = this;
        var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx)$/;
        if (regex.test($("#btnFile").val().toLowerCase())) {
            if (typeof (FileReader) != "undefined") {
                var reader = new FileReader();
                //For Browsers other than IE.
                if (reader.readAsBinaryString) {
                    reader.onload = function (e) {
                        that.ProcessExcel(e.target.result);
                    };
                    reader.readAsBinaryString($("#btnFile")[0].files[0]);
                }
                else {
                    //For IE Browser.
                    reader.onload = function (e) {
                        var data = "";
                        var bytes = new Uint8Array(e.target.result);
                        for (var i = 0; i < bytes.byteLength; i++) {
                            data += String.fromCharCode(bytes[i]);
                        }
                        that.ProcessExcel(data);
                    };
                    reader.readAsArrayBuffer($("#btnFile")[0].files[0]);
                }
            }
            else {
                alert("This browser does not support HTML5.");
            }
        }
        else {
            alert("Please upload a valid Excel file.");
        }
    };
    MemberImportComponent.prototype.ProcessExcel = function (data) {
        //Read the Excel File data.
        var workbook = XLSX.read(data, {
            type: 'binary'
        });
        //Fetch the name of First Sheet.
        var firstSheet = workbook.SheetNames[0];
        //Read all rows from First Sheet into an JSON array.
        var excelRows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet]);
        console.log(excelRows);
        this.obj_data = excelRows;
        // $('#tblData').DataTable();
    };
    MemberImportComponent.prototype.Upload = function () {
        if (this.obj_data != null) {
            if (this.obj_data.length > 0) {
                this.apiService.post('member', 'importdata', this.obj_data);
                this.util.SuccessDialog('Success Please Search For Re-Check Your Data');
            }
            else {
                this.util.ErrorDialog('Please select data file');
            }
        }
        else {
            this.util.ErrorDialog('Please select data file');
        }
    };
    return MemberImportComponent;
}());
export { MemberImportComponent };



// WEBPACK FOOTER //
// ./src/app/member/member-import/member-import.component.ts.pre-build-optimizer.js